import { IData } from '../types';

const extractInitialValues = (initialData: IData) => {
	const initialValues: { [key: string]: string } = {};
	initialData.calcFields.forEach((group) => {
		group.fields.forEach((field) => {
			initialValues[field.id] = String(field.value || '');
		});
	});
	return initialValues;
};

export default extractInitialValues;
